export default class Authenticator {
	private _tokenType: string;
	private _accessToken: string;
	private _refreshToken: string;
	private _expirationDate: Date;

	public constructor() {

		this._accessToken = localStorage.getItem('auth:accessToken') ?? '';
		this._tokenType = localStorage.getItem('auth:tokenType') ?? '';
		this._refreshToken = localStorage.getItem('auth:refreshToken') ?? '';
		this._expirationDate = new Date(parseInt(localStorage.getItem('auth:expirationDate') ?? '0'));

		if (!this._refreshToken) {
			localStorage.removeItem("auth:tokenType");
			localStorage.removeItem("auth:accessToken");
			localStorage.removeItem("auth:refreshToken");
			localStorage.removeItem("auth:expirationDate");
			localStorage.removeItem("persist:store");

			if (this._accessToken) {
				window.location.href = "/login";
			}
		}
	}

	public UseTokens(tokenType: string, accessToken: string, refreshToken: string, expirationDate: number): void {
		localStorage.setItem('auth:tokenType', tokenType);
		localStorage.setItem('auth:accessToken', accessToken);
		localStorage.setItem('auth:refreshToken', refreshToken);
		localStorage.setItem('auth:expirationDate', expirationDate.valueOf().toString());

		this._tokenType = tokenType;
		this._accessToken = accessToken;
		this._refreshToken = refreshToken;
		this._expirationDate = new Date(expirationDate);
	}

	public RefreshTokenInfo(): { refreshToken: string, expirationDate: Date } {
		return {
			refreshToken: this._refreshToken,
			expirationDate: this._expirationDate
		};
	}

	public Authenticate(request: XMLHttpRequest): void {
		if (this._tokenType && this._accessToken) {
			request.setRequestHeader('Authorization', this._tokenType + ' ' + this._accessToken);
		}
	}

	public IsAuthenticated(): boolean {
		if (!this._accessToken || !this._tokenType) {
			return false;
		}
		return this._expirationDate > new Date();
	}
	public Logout(): void {
		localStorage.removeItem('auth:tokenType');
		localStorage.removeItem('auth:accessToken');
		localStorage.removeItem('auth:refreshToken');
		localStorage.removeItem('auth:expirationDate');

		this._tokenType = '';
		this._accessToken = '';
		this._refreshToken = '';
		this._expirationDate = new Date();
	}
}
